import { calendarSelected } from '../actions/calendarActions';
import { returnTopExecutingActionDatapoint } from 'owa-analytics';
import { isSchoolCalendar } from 'owa-calendar-cache';
import { findInArray } from 'owa-calendar-data-utils/lib/findInArray';
import { getSelectedCalendars } from 'owa-calendar-surface-calendars-store';
import { selectCalendar, unselectCalendar } from 'owa-calendar-surface-select-calendar';
import { orchestrator } from 'satcheljs';

orchestrator(calendarSelected, actionMessage => {
    const { calendar: clickedCalendar } = actionMessage;

    const isCalendarSelected = findInArray(getSelectedCalendars(), calendar => {
        return (
            calendar.id.id == clickedCalendar.id.id &&
            calendar.displayName == clickedCalendar.displayName
        );
    });

    const actionDatapoint = returnTopExecutingActionDatapoint();
    actionDatapoint.addCustomData({ calendarSelected_1: !isCalendarSelected });

    if (isSchoolCalendar(clickedCalendar)) {
        actionDatapoint.addCustomData({ calendarType_2: 'School' });
    }

    if (isCalendarSelected) {
        unselectCalendar(clickedCalendar);
    } else {
        selectCalendar(clickedCalendar);
    }
});
